import { memo } from 'react';
import { DividerProps } from './divider.types';
import { StyledDivider } from './divider.styled';

export const Divider = memo(
  ({ vertical = false, fill = 'gray.200', ...restProps }: DividerProps) => {
    return <StyledDivider {...restProps} $vertical={vertical} $fill={fill} />;
  }
);
